module.exports = {
    previous: '&laquo; Previous',
    next    : 'Next &raquo;',
}